import { render } from "./TicketTags.vue?vue&type=template&id=64babae7&scoped=true"
import script from "./TicketTags.vue?vue&type=script&lang=js"
export * from "./TicketTags.vue?vue&type=script&lang=js"

import "./TicketTags.vue?vue&type=style&index=0&id=64babae7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64babae7"]])

export default __exports__